import { call, put, takeEvery, select } from 'redux-saga/effects';
import Api from '../api';
import {
    fetchMyBookStart,
    fetchMyBookSuccess,
    fetchMyBookError,
    addToMyBookStart,
    addToMyBookSuccess,
    addToMyBookError,
    removeFromMyBookStart,
    removeFromMyBookSuccess,
    removeFromMyBookError,
    updateNotesStart,
    updateNotesSuccess,
    updateNotesError,
} from '../slices/myBookSlice';

const getUserIdFromState = (state: any) => state.auth?.user?.id;

function* fetchMyBookSaga(action: any): any {
    try {
        const userId = yield select(getUserIdFromState);
        if (!userId) {
            yield put(fetchMyBookError('User not authenticated'));
            return;
        }

        const response = yield call(
            Api.getMyBook,
            userId,
            action.payload?.page || 0,
            action.payload?.size || 10
        );
        const countResponse = yield call(Api.getMyBookCount, userId);

        if (response?.data?.data) {
            const items = response.data.data;
            const total = Number(countResponse?.data?.data ?? items.length);
            yield put(
                fetchMyBookSuccess({
                    items,
                    total,
                    page: action.payload?.page || 0,
                    size: action.payload?.size || 10,
                })
            );
        } else {
            yield put(fetchMyBookError('Failed to fetch My Book'));
        }
    } catch (error: any) {
        yield put(fetchMyBookError(error.message || 'Error fetching My Book'));
    }
}

function* addToMyBookSaga(action: any): any {
    try {
        const userId = yield select(getUserIdFromState);
        if (!userId) {
            yield put(addToMyBookError('User not authenticated'));
            return;
        }

        const response = yield call(
            Api.addToMyBook,
            userId,
            action.payload.profileId,
            action.payload.notes
        );

        if (response?.data?.data) {
            yield put(addToMyBookSuccess(response.data.data));
        } else {
            yield put(addToMyBookError('Failed to add to My Book'));
        }
    } catch (error: any) {
        yield put(addToMyBookError(error.message || 'Error adding to My Book'));
    }
}

function* removeFromMyBookSaga(action: any): any {
    try {
        const userId = yield select(getUserIdFromState);
        if (!userId) {
            yield put(removeFromMyBookError('User not authenticated'));
            return;
        }

        yield call(Api.removeFromMyBook, userId, action.payload.profileId);
        yield put(removeFromMyBookSuccess(action.payload.profileId));
    } catch (error: any) {
        yield put(removeFromMyBookError(error.message || 'Error removing from My Book'));
    }
}

function* updateNotesSaga(action: any): any {
    try {
        const userId = yield select(getUserIdFromState);
        if (!userId) {
            yield put(updateNotesError('User not authenticated'));
            return;
        }

        yield call(
            Api.updateMyBookNotes,
            userId,
            action.payload.profileId,
            action.payload.notes
        );

        yield put(
            updateNotesSuccess({
                profileId: action.payload.profileId,
                notes: action.payload.notes,
            })
        );
    } catch (error: any) {
        yield put(updateNotesError(error.message || 'Error updating notes'));
    }
}

export function* myBookSaga(): any {
    yield takeEvery('myBook/fetchMyBookStart', fetchMyBookSaga);
    yield takeEvery('myBook/addToMyBookStart', addToMyBookSaga);
    yield takeEvery('myBook/removeFromMyBookStart', removeFromMyBookSaga);
    yield takeEvery('myBook/updateNotesStart', updateNotesSaga);
}
